// extracted by mini-css-extract-plugin
export default {"container":"CriticalErrorBoundary_container__lcBuf","header":"CriticalErrorBoundary_header__e+wz+","text":"CriticalErrorBoundary_text__Pusk0"};